/**
 * Import and instantiate front end modules
 */

import { updateBodyClassname } from './core/body';
import { navigationClick } from './core/navigation-click';
import { mobileNav } from './core/mobile-nav';
import { DealerMap } from './blocks/dealer-map';

updateBodyClassname();
navigationClick();
mobileNav();

// Create a dealer map controller for each instance found in the DOM
((rootSelector) => {
	document.querySelectorAll(`.${rootSelector}`).forEach(rootEl => {
		// Find elements
		const mapEl = rootEl.querySelector(`.${rootSelector}__map-placeholder`);
		const selectEl = rootEl.querySelector(`.${rootSelector}__brands select`);

		// Card elements
		const cardSelector = 'dealer-card';
		const cardEl = rootEl.querySelector(`.${rootSelector}__${cardSelector}`);
		const cardTitleEl = cardEl.querySelector(`.${cardSelector}__section--contact .dealer-card__title`);
		const addressEl = cardEl.querySelector(`.${cardSelector}__address`);
		const phoneEl = cardEl.querySelector(`.${cardSelector}__phone`);
		const emailEl = cardEl.querySelector(`.${cardSelector}__email`);
		const websiteEl = cardEl.querySelector(`.${cardSelector}__website`);
		const brandsListEl = cardEl.querySelector(`.${cardSelector}__brands-list`);

		// Instantiate and init the block handler
		new DealerMap().init({
			mapEl,
			rootEl,
			selectEl,
			cardEl,
			cardTitleEl,
			addressEl,
			phoneEl,
			emailEl,
			websiteEl,
			brandsListEl,
		});
	});
})('dealer-map');
